import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  navTitle: null,
};

export const configSlice = createSlice({
  name: "route",
  initialState,
  reducers: {
    setNavTitle: (state, action) => {
      state.navTitle = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setNavTitle } = configSlice.actions;

export default configSlice.reducer;
